import { useAuthQuery } from '@/hooks/use-auth-query'
import { transactionsApi } from '@/api'

function useCurrentMonthSpending() {
  return useAuthQuery({
    queryKey: ['current_month_spending'],
    queryFn: async () => transactionsApi.getCurrentMonthSpending(),
    refetchOnWindowFocus: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  })
}

export default useCurrentMonthSpending
